import Record from '@/components/ezuro/workschedule/components/Record.vue';
import moment from 'moment';

export default {
  name: 'Row',
  props: {
    user: {
      type: Object,
      default: null
    },
    records: {
      type: Array
    },
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    showRows: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: true
    },
    rowspanName: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: ''
    },
    showType: {
      type: Boolean,
      default: false
    },
    scheduleData: {
      type: Object
    },
    section: {
      type: String
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Record
  },
  computed: {
    companyId () {
      return this.$store.getters.getParamFromConfig('company_departments', this.departmentId, 'company_id');
    },
    currentSchedule () {
      for (const key in this.scheduleData.schedules) {
        if (
          this.scheduleData.schedules[key].department_id == this.departmentId &&
          this.scheduleData.schedules[key].division_id == this.divisionId &&
          this.scheduleData.schedules[key].type === this.type
        ) {
          return this.scheduleData.schedules[key];
        }
      }
      return null;
    },
    isDraft () {
      if (this.currentSchedule && this.currentSchedule.status == 'draft') {
        return true;
      }
      return false;
    },
    absences () {
      const absences = {};

      if (this.user) {
        for (const key in this.scheduleData.absences) {
          if (this.scheduleData.absences[key].user_id == this.user.id && this.scheduleData.absences[key].company_id == this.companyId) {
            const startDate = moment(this.scheduleData.absences[key].startDate, 'YYYY-MM-DD');
            const toDate = moment(this.scheduleData.absences[key].toDate, 'YYYY-MM-DD');
            const daysBetween = toDate.diff(startDate, 'days');
            const type = this.$store.getters.getParamFromConfig('user_absence_types', this.scheduleData.absences[key].user_absence_type_id, 'name', this.$i18n.locale);
            const code = this.$store.getters.getParamFromConfig('user_absence_types', this.scheduleData.absences[key].user_absence_type_id, 'code', this.$i18n.locale);
            const text = type + ' - ' + this.$t('work-schedule.datetime_start') + ' ' + startDate.format('DD.MM.YYYY') + ' ' + this.$t('work-schedule.datetime_end') + ' ' + toDate.format('DD.MM.YYYY');

            absences[startDate.format('YYYY-MM-DD')] = {
              code: code,
              text: text
            };

            for (let i = 0; i < daysBetween; i++) {
              absences[startDate.add(1, 'days').format('YYYY-MM-DD')] = {
                code: code,
                text: text
              };
            }
          }
        }
      }

      return absences;
    },
    totals () {
      const data = {
        d: 0,
        ssk: 0,
        sk: 0,
        ps: 0,
        skps: 0,
        bsk: 0,
        dk: 0,
        vs: 0,
        ns: 0
      };

      if (this.user && this.user.totals[this.type]) {
        const total = this.user.totals[this.type];
        data.ssk = total.holiday_minutes;
        data.sk = total.total_minutes;
        data.ps = total.absence_minutes;
        data.skps = total.total_minutes + total.absence_minutes;
        data.bsk = total.holiday_and_weekend_day_count;
        data.dk = total.day_count;
        data.vs = total.overtime_minutes;
        data.d = total.downtime_minutes;
        data.ns = total.night_minutes;
      }

      return data;
    },
    dayRecords () {
      const data = {};
      const monthStart = moment(this.scheduleData.days[Object.keys(this.scheduleData.days)[0]].sql_day);

      for (const dkey in this.scheduleData.days) {
        data[this.scheduleData.days[dkey].sql_day] = [];

        for (const rkey in this.records) {
          let recordStart = moment(this.records[rkey].datetime_start);
          const recordEnd = moment(recordStart.format('YYYY-MM-DD 23:59'));

          if (recordStart < monthStart) {
            recordStart = monthStart;
          }

          const target = moment(this.scheduleData.days[dkey].sql_day);

          if (target.isBetween(recordStart, recordEnd, 'days', '[]')) {
            data[this.scheduleData.days[dkey].sql_day].push(this.records[rkey].id);
          }
        }
      }

      return data;
    },
    editable () {
      return this.section !== 'list-my' && (this.currentSchedule === null || this.currentSchedule.status != 'confirmed');
    },
    layoutSettings () {
      return this.$store.state.hr.ezLayoutSettings;
    }
  },
  methods: {
    minutesToHours (num) {
      const hours = Math.floor(num / 60);
      const minutes = num % 60;

      return hours + 'h ' + (minutes ? minutes + '' : '');
    },
    editRecord: function (record) {
      record.department_id = this.departmentId;
      record.division_id = this.divisionId;
      record.type = this.type;
      this.$emit('editRecord', record);
    },
    addRecord: function (day) {
      if (!this.editable) return;

      const record = {
        id: null,
        user_id: null,
        department_id: this.departmentId,
        division_id: this.divisionId,
        shift_id: '',
        work_from_home: false,
        datetime_start: day.sql_day + ' 08:00',
        datetime_end: day.sql_day + ' 18:00',
        notes: '',
        type: this.type,
        schedule_id: (this.currentSchedule ? this.currentSchedule.id : null)
      };

      if (this.user && this.user.id) {
        record.user_id = this.user.id;
      }

      this.$emit('addRecord', record);
    },
    toggleRow: function () {
      this.$emit('toggle');
    },
    getTooltip: function (item) {
      let string = '';

      if (this.absences[item.sql_day]) {
        string += this.$t('work-schedule.absence') + ': ' + this.absences[item.sql_day].text;
      }

      return string;
    },
    getRecord (id) {
      for (const key in this.scheduleData.records) {
        if (this.scheduleData.records[key].id == id) {
          return this.scheduleData.records[key];
        }
      }
    },
    getRecordPosition (record) {
      const monthStart = moment(this.scheduleData.days[Object.keys(this.scheduleData.days)[0]].sql_day);
      let recordStart = moment(record.datetime_start);

      if (recordStart < monthStart) {
        recordStart = monthStart;
      }

      const dayKey = recordStart.format('YYYY-MM-DD');

      return (this.dayRecords[dayKey].indexOf(record.id) > 0 ? this.dayRecords[dayKey].indexOf(record.id) : 0);
    },
    drop: function (event, day) {
      if (!this.isDraft && this.editable) {
        return;
      }
      const recordId = event.dataTransfer.getData('record-id');
      const recordType = event.dataTransfer.getData('record-type');
      const recordCompanyId = event.dataTransfer.getData('record-company-id');

      if (recordId && recordType && recordCompanyId && this.type === recordType && parseInt(this.companyId) === parseInt(recordCompanyId)) {
        const reqData = this.BasicHelper.cloneObject(this.getRecord(recordId));
        const recordStart = moment(reqData.datetime_start);

        if (this.currentSchedule.id === reqData.schedule_id && day === recordStart.format('YYYY-MM-DD')) {
          const recordEnd = moment(reqData.datetime_end);
          const diffMinutes = moment.duration(recordEnd.diff(recordStart)).asMinutes();

          reqData.user_id = (this.user.id ? this.user.id : null);
          reqData.datetime_start = moment(day + ' ' + recordStart.format('HH:mm')).format('YYYY-MM-DD HH:mm');
          reqData.datetime_end = moment(reqData.datetime_start).add(diffMinutes, 'minutes').format('YYYY-MM-DD HH:mm');

          this.ApiRequest.request('ezuro/schedule/row/save/' + recordId, this.ApiRequest.REQUEST_POST, reqData, (response) => {
            if (response.error) {
              this.ApiRequest.displayErrorDialog(response, this);
            } else {
              this.$emit('filter');
            }
          });
        }
      }
    },
    allowDrop: function (event) {
      if (!this.isDraft && this.editable) {
        return;
      }
      const recordId = event.dataTransfer.getData('record-id');
      const recordType = event.dataTransfer.getData('record-type');
      const recordCompanyId = event.dataTransfer.getData('record-company-id');
      const fields = document.getElementsByClassName('over-drop');

      for (const key in fields) {
        if (fields[key].classList) {
          fields[key].classList.remove('over-drop');
        }
      }

      if (recordId && recordType && recordCompanyId && this.type === recordType && this.companyId === recordCompanyId) {
        const reqData = this.getRecord(recordId);

        if (this.currentSchedule.id === reqData.schedule_id) {
          event.target.classList.add('over-drop');
        }
      }
    },
    formatAbsenceCode (code) {
      return code.replaceAll('_', '<br>');
    }
  }
}
